var React = require('react');

function WorkerBlock (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"Web Worker Block","clipPath":"url(#clip0_97_121951)","key":0},React.createElement("path",{"id":"workerblockicon","fillRule":"evenodd","clipRule":"evenodd","d":"M11.3571 30L8.46429 39H1.5C0.671573 39 0 39.6716 0 40.5V46.5C0 47.3284 0.671573 48 1.5 48H46.5C47.3284 48 48 47.3284 48 46.5V40.5C48 39.6716 47.3284 39 46.5 39H39.5357L36.6429 30H11.3571ZM13.2857 24H34.7143L31.8214 15H16.1786L13.2857 24ZM18.1071 9H29.8929L27 0H21L18.1071 9Z","fill":"#8D6CFF"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_97_121951"},React.createElement("rect",{"width":"48","height":"48","fill":"white"})))]);
}

WorkerBlock.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = WorkerBlock;

WorkerBlock.default = WorkerBlock;
